import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { downloadFromApi } from 'src/common/utils/api/downloadFromApi';

type ExportParams = {
  includeInternal: boolean;
  includeMessages: boolean;
  includeConversations: boolean;
};

export function useUsageMetricsExport() {
  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useMutation<void, Error, ExportParams>({
    mutationFn: ({ includeInternal, includeMessages, includeConversations }) =>
      downloadFromApi(
        `/admin/usage-metrics/export?include_internal=${includeInternal}` +
          `&include_messages_in_total=${includeMessages}` +
          `&include_conversations_in_total=${includeConversations}`,
        'usage-metrics.xlsx',
      ),
    onError: () => {
      notifications.show({
        color: 'red',
        message: 'Could not download the usage metrics spreadsheet',
      });
    },
  });

  return {
    downloadExport: (params: ExportParams) => mutateAsync(params).catch(() => undefined),
    isLoading,
    error,
  };
}
